import React, {useEffect, useRef, useState} from 'react';
import {
  getAllSubProcesses,
  addKeyRisk,
} from '../../../services/keyRiskIndicatorsService';
import {getLanguage} from 'react-switch-lang';
import {t} from 'react-switch-lang';
import * as yup from 'yup';
import TextArea from '../../../components/FormFields/Textarea';
import './AddKeyRiskIndicator.scss';
import InputText from '../../../components/FormFields/InputText';
import {useHistory} from 'react-router-dom';
import {useForm, FormProvider} from 'react-hook-form';
import {yupResolver} from '@hookform/resolvers';
import SelectList from '../../../components/FormFields/Select';
import InputYear from '../../../components/FormFields/inputDate/InputYear';
import Toast from '../../../components/toast/Toast';
import {periods, escalationCalculationTypeOptions} from '../utils/periods';
import {appModules, validDouble} from '../../../utils/const';
import PageHeader from './PageHeader';
import SelectInfinite from '../../../components/FormFields/SelectInfinite';
import {GetPotentionalRisk, getPotentionalRisks} from '../../../services/IncurredEvent/incurredEventApi';

const AddKeyRiskIndicator = (props) => {
  const lang = getLanguage();
  const [subProcesses, setSubProcesses] = useState([]);
  const [disableSubprocess, setDisableSubProcess] = useState(true);
  const [subprocessPage, setSubprocessPage] = useState(0);
  const [hasMoreSubprocesses, setHasMoreSubprocesses] = useState(true);
  const [loadingSubprocesses, setLoadingSubprocesses] = useState(false);
  const [disabled, setDisabled] = useState(true);
  const [isKeyIndicator, setIsKeyIndicator] = useState(false);

  let history = useHistory();
  const schema = yup.object().shape({
    escalationCalculationType: yup.object().nullable().required(t('message.fieldRequired')),
    process: yup.object().nullable().required(t('message.fieldRequired')),
    subprocess: yup.object().nullable().required(t('message.fieldRequired')),
    riskIndicatorNameMne: yup
      .string()
      .required(t('message.fieldRequired'))
      .max(255, t('message.max', {max: 255})),
    escalationPointValue: yup
      .string()
      .trim()
      .required(t('message.fieldRequired'))
      .matches(validDouble, t('message.onlyDecimalNumbersMinZero'))
      .typeError(t('message.onlyDecimalNumbersMinZero'))
      .max(20, t('message.max', {max: 20})),
    period: yup.object().nullable().required(t('message.fieldRequired')),
    escalationDescription: yup
      .string()
      .required(t('message.fieldRequired'))
      .max(255, t('message.max', {max: 255})),
    department: yup.object().nullable().required(t('message.fieldRequired')),
    riskDescriptionMne: yup
      .string()
      .required(t('message.fieldRequired'))
      .max(2048, t('message.max', {max: 2048})),
    year: yup.string().nullable().required(t('message.fieldRequired')),
    potentialRiskId: yup.object().nullable().required(t('message.fieldRequired')),
  });
  const defaultEscalationCalculationType =
    escalationCalculationTypeOptions.find(
      (item) => item.value === 'COUNTER'
    );
  const methods = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      escalationCalculationType: defaultEscalationCalculationType,
    }
  });
  const {handleSubmit, setValue, watch} = methods;
  const prevProcessRef = useRef();

  const watchProcess = watch('process');
  const watchPotentialRiskId = watch('potentialRiskId');
  const [potentionalRisks, setPotentionalRisks] = useState([]);

  useEffect(() => {
    fetchPotentionalRisks().then((r) => {
      let options = [];
      r.forEach((item) => {
        options.push({
          value: item.id,
          label: item.title,
        });
      });
      setPotentionalRisks(options);
    });

    if (
      props?.location?.state !== null &&
      props?.location?.state !== undefined
    ) {
      const potentialId = props?.location?.state.potentialId;
      const potentialTitle = props?.location?.state.potentialTitlе;
      setValue(
        'potentialRiskId',
        {value: potentialId, label: potentialTitle},
        {
          shouldValidate: false,
          shouldDirty: false,
        }
      );
    }
  }, []);
  useEffect(() => {
    if (watchPotentialRiskId?.value) {
      setDisabled(false);
      const fetchRiskData = async () => {
        try {
          const {data} = await GetPotentionalRisk(watchPotentialRiskId?.value);
          setValue(
            'subprocess',
            {
              value: data[0].subprocessId,
              label:
                lang === 'mne'
                  ? data[0].subprocessName
                  : data[0].subprocessNameEn,
            },
            {
              shouldValidate: true,
              shouldDirty: false,
            }
          );
          setValue(
            'process',
            {
              value: data[0].processId,
              label:
                lang === 'mne' ? data[0].processName : data[0].processNameEn,
            },
            {
              shouldValidate: true,
              shouldDirty: false,
            }
          );
          setValue('riskDescriptionMne',data[0].description);
        } catch (err) {
          // console.log(err, 'error');
        }
      };

      fetchRiskData();
    }
  }, [watchPotentialRiskId]);

  const fetchSubprocesses = async (pageToLoad = 0, replace = false) => {
    if (!watchProcess?.value) return;
    try {
      setLoadingSubprocesses(true);
      const {data} = await getAllSubProcesses(
        watchProcess?.value,
        20,
        pageToLoad
      );

      const mapped = data?.map((item) =>
        lang === 'eng'
          ? {value: item?.id, label: item?.nameEn}
          : {value: item?.id, label: item?.name}
      );

      setSubProcesses(prev =>
        replace ? mapped : [...prev, ...mapped]
      );

      setSubprocessPage(pageToLoad);
      setHasMoreSubprocesses(data.length === 20);
    }
    catch (e){
    }finally {
      setLoadingSubprocesses(false);
    }
  };

  useEffect(() => {
    if (watchProcess?.value) {
      setDisableSubProcess(false);

      const processChanged =
        prevProcessRef.current !== undefined &&
        prevProcessRef.current !== watchProcess.value;

      if (processChanged) {
        setValue('subprocess', '', {
          shouldValidate: false,
          shouldDirty: false,
        });

        setSubProcesses([]);
        setSubprocessPage(0);
        setHasMoreSubprocesses(true);
      }

      prevProcessRef.current = watchProcess.value;

      fetchSubprocesses(0, true);
    } else {
      setDisableSubProcess(true);
      setSubProcesses([]);
      setSubprocessPage(0);
      setHasMoreSubprocesses(true);
      prevProcessRef.current = undefined;

      setValue('subprocess', '', {
        shouldValidate: false,
        shouldDirty: false,
      });
    }
  }, [watchProcess]);
  const fetchPotentionalRisks = async () => {
    try {
      const {data} = await getPotentionalRisks();
      return data;
    } catch (e) {}
  };

  const goBack = () => {
    history.push('/key-risk-indicators');
  };

  const onSubmit = async (e) => {
    const date = new Date(e.year);
    const year = date.getFullYear();
    const body = {
      potentialRiskId: e?.potentialRiskId?.value,
      departmentId: e.department['value'],
      departmentName: lang === 'mne' ? e.department['label'] : '',
      departmentNameEn: lang === 'eng' ? e.department['label'] : '',
      description: e.escalationDescription,
      indicatorName: e.riskIndicatorNameMne,
      indicatorPeriod: e.period['value'],
      minValue: e.escalationPointValue,
      processId: e.process['value'],
      processName: lang === 'mne' ? e.process['label'] : '',
      processNameEn: lang === 'eng' ? e.process['label'] : '',
      riskDescription: e.riskDescriptionMne,
      subprocessId: e.subprocess['value'],
      subprocessName: lang === 'mne' ? e.subprocess['label'] : '',
      subprocessNameEn: lang === 'eng' ? e.subprocess['label'] : '',
      year: year,
      isKeyIndicator: isKeyIndicator,
      escalationCalculationType: e?.escalationCalculationType?.value
    };
    try {
      const response = await addKeyRisk(body);
      if (response.status === 201) {
        await Toast.fire({
          title: t('Pages.messages.addSuccess', {
            entity:
              lang === 'eng'
                ? 'Key risk indicator'
                : 'Ključni indikator rizika',
          }),
          icon: 'success',
        });
        await history.push(`/key-risk-indicators`);
      }
    } catch (err) {
      if (err.response.data.code === 'indicator-exists') {
        Toast.fire({
          title:
            lang === 'eng'
              ? err.response.data.description
              : t('Pages.messages.sameIndicatorAdded'),
          icon: 'error',
        });
        document.getElementById('riskIndicatorNameMne').focus();
        document.getElementById('riskIndicatorNameMne').select();
      }
    }
  };
  const handleSubprocessLoadMore = () => {
    if (hasMoreSubprocesses && !loadingSubprocesses) {
      fetchSubprocesses(subprocessPage + 1, false);
    }
  };
  return (
    <div>
      <PageHeader/>
      <div className="administration-template content">
        <FormProvider {...methods}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-4 col-xl-3 pl-0">
                  <div className="title mb-3">
                    {t('Pages.AddKeyRiskIndicator.indicators')}
                  </div>
                  <div className="form-group mb-4">
                    <label className="label" htmlFor="riskIndicatorNameMne">
                      {t('Pages.AddKeyRiskIndicator.keyRiskNameMne')}
                    </label>
                    <InputText
                      name="riskIndicatorNameMne"
                      id="riskIndicatorNameMne"
                      className="form-control"
                      placeholder={t('Pages.AddKeyRiskIndicator.placeholder.keyRiskNameMne')}
                      defaultValue={
                        props.location.state
                          ? props.location.state.keyRisk.riskIndicatorNameMne
                          : ''
                      }
                    />
                  </div>
                  <label className="label">
                    <input
                      name={"isKeyIndicator"}
                      className='mr-5 mt-1'
                      type="checkbox"
                      id={`checkbox-single`}
                      checked={isKeyIndicator}
                      onChange={(e) => setIsKeyIndicator(e.target.checked)}
                    />
                    <span className="pl-2">{t("Pages.KeyRiskIndicators.isKeyIndicator")}</span>
                  </label>
                </div>
                <div className="col-md-4 col-xl-3">
                  <div className="title mb-3">
                    {t('incurred-risk.potentionalRisk')}
                  </div>
                  <label className="label">
                    {t('incurred-risk.potentionalRisk')}
                  </label>
                  <div className="form-group mb-4">
                    <SelectInfinite
                      api="/risks?riskTypeId.equals=1&riskStatusId.in=1,2,3"
                      name="potentialRiskId"
                      placeholder={t('incurred-risk.placeholder.potentionalRisk')}
                      labelKey={'title'}
                      className="select"
                      isClearable
                      queryKeys={'title.contains'}
                      isSelectWithId={true}
                    />
                  </div>
                  <div className="form-group mb-4">
                    <label className="label" htmlFor="riskDescriptionMne">
                      {t('Pages.AddKeyRiskIndicator.riskDescMne')}
                    </label>
                    <TextArea
                      name="riskDescriptionMne"
                      placeholder={t('Pages.AddKeyRiskIndicator.placeholder.riskDescMne')}
                      disabled={true}
                    />
                  </div>
                  <div className="title mb-3">
                    {t('Pages.AddKeyRiskIndicator.processesAndSubprocesses')}
                  </div>
                  <div className="form-group mb-4">
                    <label className="label" htmlFor="process">
                      {t('Pages.AddKeyRiskIndicator.processes')}
                    </label>
                    <SelectInfinite
                      api="processes?active.equals=true"
                      name="process"
                      placeholder={t('common.select')}
                      labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                      className="select"
                      isDisabled={true}
                      ref={prevProcessRef}
                    />
                  </div>
                  <div className="form-group mb-4">
                    <label className="label" htmlFor="subprocess">
                      {t('Pages.AddKeyRiskIndicator.subprocesses')}
                    </label>
                    <SelectList
                      name="subprocess"
                      isDisabled={true}
                      placeholder={t('common.select')}
                      options={subProcesses}
                      isClearable
                      onLoadMore={handleSubprocessLoadMore}
                      hasMore={hasMoreSubprocesses}
                      isLoading={loadingSubprocesses}
                    />
                  </div>
                </div>
                <div className="col-md-4 col-xl-3">
                  <div className="title mb-3">
                    {t('Pages.AddKeyRiskIndicator.escalation')}
                  </div>
                  <label className='label w-100 mt-2'>
                    {t('Pages.KeyRiskIndicators.escalationCalculationType')}
                  </label>
                  <SelectList
                    name="escalationCalculationType"
                    className="select pb-4"
                    options={escalationCalculationTypeOptions}
                    placeholder={t('Pages.KeyRiskIndicators.placeholder.escalationCalculationType')}
                    isClearable={true}
                  />
                  <div className="row mb-4 d-flex flex-md-column flex-lg-row">
                      <div className="col-md-12 col-lg-6">
                      <label className="label" htmlFor="escalationPointValue">
                        {t('Pages.AddKeyRiskIndicator.escalationPointValue')}
                      </label>
                      <InputText
                        name="escalationPointValue"
                        type="text"
                        className="form-control"
                        defaultValue={
                          props.location.state
                            ? props.location.state.keyRisk.minValue
                            : ''
                        }
                      />
                    </div>
                    <div className="col-md-12 col-lg-6">
                      <label className="label" htmlFor="period">
                        {t('Pages.AddKeyRiskIndicator.escalationPointPeriod')}
                      </label>
                      <SelectList
                        name="period"
                        options={periods}
                        placeholder={t('common.select')}
                        defaultValue={
                          props.location.state
                            ? props.location.state.keyRisk.indicatorPeriod
                            : ''
                        }
                      />
                    </div>
                  </div>
                  <div className="form-group mb-4">
                    <label className="label" htmlFor="escalationDescription">
                      {t('Pages.AddKeyRiskIndicator.escalationPointDesc')}
                    </label>
                    <TextArea
                      name="escalationDescription"
                      placeholder=   {t('Pages.AddKeyRiskIndicator.placeholder.escalationPointDesc')}
                      defaultValue={
                        props.location.state
                          ? props.location.state.keyRisk.description
                          : ''
                      }
                    />
                  </div>
                </div>

                <div className="col-md-4 col-xl-3">
                  <div className="title mb-3">
                    {t('Pages.AddKeyRiskIndicator.organization')}
                  </div>
                  <div className="form-group mb-4">
                    <label className="label" htmlFor="department">
                      {t('Pages.AddKeyRiskIndicator.department')}
                    </label>
                    <SelectInfinite
                      api={`departments?appModuleId.equals=${appModules?.riskModule}&active.equals=true`}
                      name="department"
                      placeholder={t('common.select')}
                      labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                      className="select"
                      defaultValue={
                        props.location.state
                          ? props.location.state.keyRisk.department
                          : ''
                      }
                    />
                  </div>
                  <div className="title mb-3">
                    {t('Pages.AddKeyRiskIndicator.year')}
                  </div>
                  <div className="form-group d-flex flex-column">
                    <label className="label" htmlFor="year">
                      {t('Pages.AddKeyRiskIndicator.year')}
                    </label>
                    <InputYear
                      name="year"
                      key={props.location.state}
                      // defaultValue={
                      //   props.location.state
                      //     ? props.location.state.keyRisk.year
                      //     : ''
                      // }
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="container-fluid mt-4">
              <div className="row">
                <div className="col-12 pt-4 pb-4 d-flex justify-content-end footer">
                  <button
                    className="secondary-btn"
                    onClick={(event) => {
                      event.preventDefault();
                      goBack();
                    }}
                  >
                    {t('common.cancel')}
                  </button>
                  <button className="primary-btn">{t('common.save')}</button>
                </div>
              </div>
            </div>
          </form>
        </FormProvider>
      </div>
    </div>
  );
};

export default AddKeyRiskIndicator;
